import { useContent } from '../App.jsx';
import PageHero from '../components/PageHero.jsx';
import { ArrowIcon } from '../components/Icons.jsx';

export default function ContactPage() {
  const { content } = useContent();
  return (
    <>
      <PageHero eyebrow="Let's talk" title="Questions before the first note?" body="Whether you are deciding which track fits, registering a group, or planning your trip, we are happy to help." />
      <section className="section page-width contact-layout">
        <div className="contact-primary">
          <p className="eyebrow">Workshop contact</p>
          <h2>Traci Cooper</h2>
          <a href={`mailto:${content.site.contactEmail}`}>{content.site.contactEmail}<ArrowIcon /></a>
          <p>We typically respond within a couple of days. During workshop week, please allow a little extra time.</p>
        </div>
        <div className="contact-links">
          <a href={content.site.facebookUrl} target="_blank" rel="noreferrer"><span>Facebook</span><ArrowIcon /></a>
          <a href={content.site.twitterUrl} target="_blank" rel="noreferrer"><span>X / Twitter</span><ArrowIcon /></a>
        </div>
      </section>
    </>
  );
}
